
  import React from "react"
  import Component from "/opt/build/repo/docs-www/src/layouts/walkin_default.js"
  import data from "/opt/build/repo/docs-www/.cache/json/layout-walkin-default.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/walkin_default.js